export const Style = {
    HalfEind: {numb: 0},
    Default: {numb: 1},
}